export default __webpack_public_path__ + "static/media/Foto galerija 5.6f07a18c.jpg";